import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/compras', documento: 'pos-settings', acceso: 'sesion',
  filas: ['071'], cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:129',
} satisfies RutaProd;
